// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const PersonFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 26">
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1.25 24.25a9.75 9.75 0 1 1 19.5 0M16.25 7a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const PersonFillOffset: IconOffset = {
    vertical: 2, // Store Custom Code
    horizontal: 7, // Store Custom Code
};

export default React.memo(PersonFill);
